import { mapState, mapActions } from 'vuex';
import _ from 'lodash';
import { node as DycolorNode, editor as DycolorEditor } from 'gotu-vue-dycolor';
import { dycolor, Debug, initDycolor, Header, permissions, setup } from '~';
import KeyCombo from '@/directives/key-combo';

initDycolor('app-global', require(`${process.env.DYCOLOR_REQUIRE}./AppGlobal.scss`)); // eslint-disable-line
_.forOwn(dycolor, (value, key) => initDycolor(key, value));

const debug = Debug('app');

export default {
  directives: {
    'v-key-combo': KeyCombo,
  },
  data() {
    return {
      loading: true,
      hideColorPicker: true,
      logo: false,
      error: null,
    };
  },
  components: {
    'app-header': Header,
    'dycolor-node': DycolorNode,
    'dycolor-editor': DycolorEditor,
    // 'color-picker': ColorPicker,
  },
  computed: {
    ...mapState('publicConfig', { publicConfig: 'config' }),
    ...mapState('router', {
      currentRoutePath: 'fullPath',
      isCurrentRoutePublic: state => _.get(state, 'meta.public', false),
      noTemplate: state => _.get(state, 'meta.noTemplate', false),
      token: state => _.get(state, 'query.token', null),
    }),
    ...mapState('auth', { currentUser: 'user' }),
    menuItems() {
      const topItems = [];

      if (this.currentUser && !this.currentUser.only_campaign) {
        topItems.push({
          text: this.$t('pos.header.campaigns_list'),
          to: { name: 'campaigns' },
        });
      }

      if (permissions.canGlobal(this.currentUser, 'Creative', ['viewAll'])) {
        topItems.push({
          text: this.$t('pos.header.creatives'),
          to: { name: 'creatives' },
        });
      }

      if (permissions.canGlobal(this.currentUser, 'User', ['loginLab'])) {
        topItems.push({
          text: this.$t('pos.header.customers'),
          to: { name: 'customers' },
        });
      }

      if (permissions.canGlobal(this.currentUser, 'Campaign', ['validateCampaigns'])) {
        topItems.push({
          text: this.$t('pos.header.campaign-validate'),
          to: { name: 'campaign-validate' },
        });
      }

      return {
        top: topItems,
        submenu: [
          {
            text: this.$t('pos.header.account'),
            to: { name: 'account' },
          },
        ],
      };
    },
  },
  methods: {
    ...mapActions('publicConfig', { updatePublicConfig: 'updateConfig' }),
  },
  mounted() {
    setup.setupClientConfig(process.env.API_URL, process.env.FETCH_CONFIG)
      .then(() => this.updatePublicConfig('lab'))
      .then(() => {
        const disabledLanguages = _.get(this.publicConfig, 'lab.disabled_locales', []);
        let interfaceLanguages = _.get(this.publicConfig, 'interface_languages', []);
        interfaceLanguages = interfaceLanguages.filter(l => !disabledLanguages.includes(l));
        return setup.setupLocalization(
          'lab',
          interfaceLanguages,
          _.cloneDeep(_.get(this.publicConfig, 'common_translations', {})),
          this.publicConfig,
        );
      })
      .then(() => {
        const design = Object.assign({}, _.get(this.publicConfig, 'lab'), _.get(this.publicConfig, 'rabbit'));
        return setup.setupDesign(design).then(logo => this.logo = logo);
      })
      .then(() => {
        if (this.token) {
          return Promise.resolve();
        }

        return setup.setupAutologin(
          this.isCurrentRoutePublic,
          this.currentRoutePath,
          newRoute => this.$router.push(newRoute),
        );
      })
      .then(() => {
        this.loading = false;
      })
      .catch(error => {
        debug.error('Error during setup: %o', error);
        this.error = String(error);
      });

    this.$on('keycombo::success', () => {
      this.hideColorPicker = !this.hideColorPicker;
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/app/App.js